module.exports = __webpack_public_path__ + "img/5.ea46c888.png";